<template>
  <section :class="[$options.name, { mobile: isMobile }]">
    <EdroneHeader v-if="title || subtitle" type="h1" mobile-type="h2" :title="title" :desc="subtitle" :centered="true" class="tw:mb-6" />
    <slot></slot>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import EdroneHeader from "vue-app/edroneComponents/EdroneHeader.vue";

export default defineComponent({
  name: "AccountContent",
  components: {
    EdroneHeader,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  },
});
</script>

<style lang="scss">
@use "vue-app/assets/scss/views/account/account.scss";
</style>
